module.exports = __webpack_public_path__ + "img/framework.15e64a93.png";